import type { MenuItemDefinition } from './typing';

export const createMenuItemDefinition = <Product, MenuItemId extends string>(
    definition: MenuItemDefinition<Product, MenuItemId>,
): MenuItemDefinition<Product, MenuItemId> => definition;
